import { TeamRole, Team, User } from '@graphql/generated';
import { TeamAndIsMember } from '@src/types/team';

export const selectableTeamRoles = Object.values(TeamRole).filter(
  (role) => role != TeamRole.Owner
);

export const TEAM_ROLE_DESCRIPTIONS: Record<string, string> = {
  [TeamRole.Admin]:
    'Can access team projects, create new ones, manage roles & permission and invite new people.',
  [TeamRole.Member]: 'Can access team projects and invite new people.',
};
export const selectableAllTeamRoles = Object.values(TeamRole);

export const defaultTeamRole = TeamRole.Member;
export const getTeamRoleEnumValue = (role: string) => {
  const indexOfRole = Object.values(TeamRole).indexOf(role as TeamRole);
  return Object.values(TeamRole)[indexOfRole];
};

export const convertTeamsToTeamAndIsMember = (
  teams: Team[],
  myId: User['id']
): TeamAndIsMember[] => {
  return teams.map((t): TeamAndIsMember => {
    return {
      ...t,
      isMember: !!t.users.find((user) => user.id === myId),
    };
  });
};

export const sortTeamsByIsMember = (
  teamsWithIsMember: TeamAndIsMember[]
): TeamAndIsMember[] => {
  return teamsWithIsMember.sort((a, _b) => (a.isMember ? -1 : 1));
};

export const isTeamPlanActive = (team?: Team) => {
  if (!team) return false;
  if (
    isTrialEnded({
      subscriptionDetails: {
        currentPeriodEnd: team?.subscriptionDetails?.expirationDate,
      },
    })
  ) {
    return false;
  }
  return true;
};

export const canUploadFileToTeam = (team?: Team) => {
  if (!team) return false;
  let disableUpload = !isTeamPlanActive(team);
  const storageRemaining = Number(team?.storageRemaining);
  if (!isNaN(storageRemaining)) {
    // if team plan is inactive, but has remaining storage, still can upload
    disableUpload = disableUpload || storageRemaining <= 0;
  }
  return disableUpload;
};

export const isTrialEnded = (team?: {
  subscriptionDetails: { currentPeriodEnd: string | number | Date };
}) => {
  if (team?.subscriptionDetails?.expirationDate) {
    const trialEndDate = new Date(team?.subscriptionDetails?.expirationDate);
    const currentDate = new Date();
    return trialEndDate < currentDate;
  }
  return false;
};
